import React from "react";
import {
  RiCheckLine,
  RiTimeLine,
  RiCloseCircleLine,
  RiFileCopy2Line,
} from "@remixicon/react";
import { Link } from "react-router-dom";
const StatusIcon = ({ status }) => {
  switch (status) {
    case "PAID":
      return (
        <div className="bg-green-500 rounded-full p-3 w-14 h-14 flex items-center justify-center mx-auto mb-2">
          <RiCheckLine className="text-white" size={32} />
        </div>
      );
    case "PENDING":
      return (
        <div className="border-2 border-dashed border-orange-500 rounded-full p-3 w-14 h-14 flex items-center justify-center mx-auto mb-2">
          <RiTimeLine className="text-orange-500 animate-pulse" size={32} />
        </div>
      );
    case "CANCELLED":
      return (
        <div className="bg-red-500 rounded-full p-3 w-14 h-14 flex items-center justify-center mx-auto mb-2">
          <RiCloseCircleLine className="text-white" size={32} />
        </div>
      );
    default:
      return null;
  }
};

const StatusText = ({ status }) => {
  switch (status) {
    case "PAID":
      return (
        <div className="text-green-500 text-lg font-medium">
          Giao dịch thành công
        </div>
      );
    case "PENDING":
      return (
        <div className="text-orange-500 text-lg font-medium">
          Chờ thanh toán
        </div>
      );
    case "CANCELLED":
      return (
        <div className="text-red-500 text-lg font-medium">Hủy giao dịch</div>
      );
    default:
      return null;
  }
};

const TransactionCard = ({
  id,
  transactionCode,
  paymentType,
  status,
  amount,
  bankName,
  accountNumber,
  isPaid,
  isCanceled,
  qrCodeUrl,
  created,
  paid,
  canceled,
  description,
  paymentLink
}) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  let borderColor = "border-gray-200";
  if (status === "PAID") borderColor = "border-green-500";
  if (status === "PENDING") borderColor = "border-red-500";
  if (status === "CANCELLED") borderColor = "border-red-700";

  return (
    <div
      className={`rounded-3xl border p-5 relative ${borderColor} background-wallet`}
    >
      <div className="text-center">
        {/* <div className="ont-medium text-lg mb-2">
          CheaperCourse Payment Auto
        </div> */}
        <div className="min-h-[150px] inline-block align-middle">
          <StatusIcon status={status} />
          <StatusText status={status} />
          {status === 'PENDING' && <Link to={paymentLink} className="text-blue mt-2" color="blue" target='_blank'>Đến trang thanh toán</Link>}
        </div>
      </div>

      <div className="mt-3 text-left">
        <div className="flex items-center justify-between text-sm">
          <span className="">Amount:</span>
          <div className="flex items-center gap-1">
            <span className="font-medium">{amount} đ</span>
            <button
              onClick={() => handleCopy(amount)}
              className="focus:outline-none"
            >
              <RiFileCopy2Line className=" hover:text-gray-300" size={16} />
            </button>
          </div>
        </div>

        {/* <div className="flex items-center justify-between mt-3 text-sm">
          <span className="">Ngân hàng:</span>
          <span>{bankName}</span>
        </div>

        <div className="flex items-center justify-between mt-3 text-sm">
          <span className="">Account number:</span>
          <div className="flex items-center gap-1">
            <span className="font-medium">{accountNumber}</span>
            <button
              onClick={() => handleCopy(accountNumber)}
              className="focus:outline-none"
            >
              <RiFileCopy2Line className="" size={16} />
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between mt-3 text-sm">
          <span className="">Chủ tài khoản:</span>
          <span className={"font-medium"}></span>
        </div> */}

        <div className="mt-4">
          <span className=" text-sm">Nội dung chuyển khoản:</span>
          <div className="border border-dashed border-blue-300 rounded-md p-3 mt-1 flex items-center justify-between">
            <span className="font-medium">{description}</span>
            <button
              onClick={() => handleCopy(description)}
              className="focus:outline-none"
            >
              <RiFileCopy2Line className=" " size={16} />
            </button>
          </div>
        </div>
      </div>

      {isPaid && (
        <div className="mt-4 text-center">
          <div className="inline-flex items-center gap-1 bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs">
            <RiCheckLine className="text-xs" />
            <span>Completed, {paid}</span>
          </div>
        </div>
      )}

      {status === "PENDING" && (
        <div className="mt-4 text-center">
          <div className="inline-flex items-center gap-1 bg-blue-100 hover:bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-xs">
            <RiCloseCircleLine className="text-sm" />
            <span>Unpaid</span>
          </div>
        </div>
      )}

      {isCanceled && (
        <div className="mt-4 text-center">
          <div className="inline-flex items-center gap-16 bg-blue-100 hover:bg-blue-200 text-red-800  px-3 py-1 rounded-full text-xs">
            <RiCloseCircleLine className="text-sm" />
            <span>Canceled, {canceled}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionCard;
